<div class="control-section">
  <div class="e-img-editor-sample" style="width: 743px; height: 300px">
    <ejs-imageeditor
      id="image-editor-two"
      (created)="uploadSignature()"
      [toolbar]="customToolbardata"
      (toolbarItemClicked)="toolbarItemClickedForImage($event)"
      (fileOpened)="openSignature($event)"
    ></ejs-imageeditor>
  </div>
</div>
